/**
 * ConditionChip.js — Chip for a single condition in the WHEN pipeline
 *
 * Shows a summary label in collapsed state.
 * Click to expand for inline editing via ChipExpansionPanel.
 */

import { X } from 'lucide-react';
import { cn } from '../../../../lib/utils';

const getConditionLabel = (condition) => {
  if (!condition) return 'condition';
  switch (condition.type) {
    case 'resource_available':
      return `Has ${condition.resource || 'resource'}`;
    case 'has_token':
      return condition.tokenId ? `Has Token: ${condition.tokenId}` : 'Has Token';
    case 'not_active':
      return condition.stateKey ? `Not Active: ${condition.stateKey}` : 'Not Active';
    case 'is_active':
      return condition.stateKey ? `Is Active: ${condition.stateKey}` : 'Is Active';
    case 'not_on_cooldown':
      return condition.cooldownKey ? `Off Cooldown: ${condition.cooldownKey}` : 'Off Cooldown';
    case 'hp_below':
      return condition.threshold != null ? `HP < ${condition.threshold}` : 'HP Below';
    case 'level_at_least':
      return condition.level != null ? `Level >= ${condition.level}` : 'Level Check';
    case 'has_character_flag':
      return condition.flag ? `Has Flag: ${condition.flag}` : 'Has Flag';
    case 'not_has_character_flag':
      return condition.flag ? `No Flag: ${condition.flag}` : 'No Flag';
    case 'has_ancestry':
      return condition.ancestry ? `Ancestry: ${condition.ancestry}` : 'Has Ancestry';
    case 'has_class':
      return condition.class ? `Class: ${condition.class}` : 'Has Class';
    default:
      return condition.type || 'condition';
  }
};

const ConditionChip = ({ item, index, isExpanded, onToggleExpand, onRemove, colorScheme }) => (
  <div
    className={cn(
      'inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm cursor-pointer',
      'transition-all',
      colorScheme.chipBg,
      colorScheme.chipText,
      isExpanded && 'ring-1 ring-blue-500'
    )}
  >
    <button
      type="button"
      onClick={() => onToggleExpand(index)}
      aria-expanded={isExpanded}
      aria-label={`Edit condition: ${getConditionLabel(item)}`}
      className="select-none text-sm bg-transparent border-0 p-0 cursor-pointer text-inherit"
    >
      {getConditionLabel(item)}
    </button>
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onRemove(index); }}
      aria-label={`Remove condition: ${getConditionLabel(item)}`}
      className="ml-0.5 hover:text-white transition-colors p-1 min-w-[28px] min-h-[28px] flex items-center justify-center"
    >
      <X size={14} />
    </button>
  </div>
);

export { getConditionLabel };
export default ConditionChip;
